import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  AcceptCommercialRelease, CommercialReleaseSummary,
  RejectCommercialRelease,
} from "@portbase/bezoekschip-service-typescriptmodels";
import {PortvisitUtils} from "../../../refdata/portvisit-utils";
import {sendCommand} from "../../../common/utils";
import {AppContext} from "../../../app-context";

@Component({
    selector: 'app-commercial-release-admin',
    templateUrl: './commercial-release-admin.component.html',
    styleUrls: ['./commercial-release-admin.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommercialReleaseAdminComponent {
  @Input() summary: CommercialReleaseSummary;
  @Input() rejectionReasons = "Rejected by Portbase";
  utils = PortvisitUtils;
  appContext = AppContext;

  acceptRelease() {
    sendCommand('com.portbase.bezoekschip.common.api.commercialrelease.AcceptCommercialRelease',
      <AcceptCommercialRelease>{id: this.summary.id},
      () => AppContext.registerSuccess('The release has been accepted manually.'))
  }

  rejectRelease() {
    sendCommand('com.portbase.bezoekschip.common.api.commercialrelease.RejectCommercialRelease',
      <RejectCommercialRelease>{id: this.summary.id, reasons: this.rejectionReasons},
      () => AppContext.registerSuccess('The release has been rejected manually.'))
  }

  adminAllowedToManipulateCR() {
    // in production, the terminal communication goes wrong; this is not solved by manipulating the CR, it only SEEMS to solve it
    // On any other environment, even KT, there is no sensible communication with terminals, so the actions are safe
    if (AppContext.isProduction()) return false;

    return this.summary.releaseStatus?.status === 'DECLARED';
  }
}
